export const signPath = 'Sign';
export const inPath = 'In';
export const upPath = 'Up';

export const addressesSign = {
  signPath: `/${signPath}`,
  inPath: `/${signPath}/${inPath}`,
  upPath: `/${signPath}/${upPath}`,
};
